import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"
import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface PurchaseOrderAddAlertProps {
  onAdd: () => void
}

export const PurchaseOrderAddAlert: FC<PurchaseOrderAddAlertProps> = ({ onAdd }) => {
  const { hasPermissions } = usePermissionManager()
  const canMaintain = hasPermissions([PermissionActionType.WAREHOUSE_RECEIVING_MAINTENANCE])

  return (
    <InformationMissingAlert
      description="No PO's have been added yet. Once you add some, you will be able to see them here."
      {...(canMaintain && {
        title: "Attach a Purchase Order to get started",
        action: (
          <Button
            color='inherit'
            size='small'
            appearance='outlined'
            startIcon={<AddOutlined />}
            onClick={onAdd}
            data-testid='add-purchase-order-button'
          >
            Add PO
          </Button>
        ),
      })}
    />
  )
}
